import React, { useRef, useImperativeHandle, forwardRef, useState } from "react";

// Canvas pro podpis prstem i myší. Rodič si přes ref vezme dataURL (PNG) nebo null.
const SignaturePad = forwardRef(function SignaturePad({ height = 120 }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  const pos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - rect.left) * (c.width / rect.width), y: (t.clientY - rect.top) * (c.height / rect.height) };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#14161a";
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    dirty.current = true;
    if (!hasInk) setHasInk(true);
  };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    dirty.current = false;
    setHasInk(false);
  };

  useImperativeHandle(ref, () => ({
    getDataURL: () => (dirty.current ? canvasRef.current.toDataURL("image/png") : null),
    clear,
    isEmpty: () => !dirty.current,
  }));

  return (
    <div>
      <div className="relative rounded-card border border-dashed border-line-strong bg-[#fbfbf9]" style={{ height }}>
        <canvas
          ref={canvasRef}
          width={640}
          height={height * 2}
          data-testid="signature-canvas"
          className="w-full h-full touch-none"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
        {!hasInk && (
          <span className="absolute inset-0 flex items-center justify-center text-[12.5px] text-muted pointer-events-none">
            Podepiš prstem sem
          </span>
        )}
      </div>
    </div>
  );
});

export default SignaturePad;
